import "./Button.scss";
import { ClipLoader } from "react-spinners";

function Button({ type, isLoading, label, className = "", onClick, disabled }) {
  return (
    <button 
      className={className} 
      type={type} 
      disabled={isLoading || disabled}
      onClick={onClick}
    >
      { isLoading && <ClipLoader color={"#ffffff"} className="loader" />} <span>{label}</span>
    </button>
  );
}

export default Button;
